import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  EoStepPanelConfig,
  EoStepperConfig,
  IEoStepPanelConfig,
} from './eo-stepper.model';

@Component({
  selector: 'eo-stepper',
  templateUrl: './eo-stepper.component.html',
  styleUrl: './eo-stepper.component.scss',
})
export class EoStepperComponent {
  private _config?: EoStepperConfig;
  @Input() set config(value: EoStepperConfig) {
    this._config = value;
    this._config.panels = this._config.panels.sort((n1, n2) => {
      return n1.index - n2.index;
    });
  }
  get config(): EoStepperConfig | undefined {
    return this._config;
  }
  @Input() stepContent?: TemplateRef<any>[] | TemplateRef<any>;

  onActiveStepChange(event: number) {
    if (!this.config) return;

    this.config.activeStep = event;
    this.config.activeStepChange?.(event);
  }

  onNextClick(nextCallback: any, panel: EoStepPanelConfig): void {
    if (panel.nextButtonClick) {
      panel.nextButtonClick(panel);
      return;
    }

    if (this.config?.nextButtonClick) {
      this.config.nextButtonClick(panel);
      return;
    }

    nextCallback.emit();
  }

  onPreviousClick(prevCallback: any, panel: EoStepPanelConfig): void {
    if (panel.previousButtonClick) {
      panel.previousButtonClick(panel);
      return;
    }

    if (this.config?.previousButtonClick) {
      this.config.previousButtonClick(panel);
      return;
    }

    prevCallback.emit();
  }

  onSubmitClick(): void {
    if (!this.config?.submitButtonClick) return;

    this.config.submitButtonClick(null);
  }

  isPreviousButtonLoading(panel: EoStepPanelConfig): boolean {
    let panelVal = this.getFnValue<boolean>(panel?.previousButtonLoading);
    let configVal = this.getFnValue<boolean>(
      this.config?.previousButtonLoading
    );

    return panelVal ?? configVal ?? false;
  }

  isNextButtonLoading(panel: EoStepPanelConfig): boolean {
    let panelVal = this.getFnValue<boolean>(panel?.nextButtonLoading);
    let configVal = this.getFnValue<boolean>(this.config?.nextButtonLoading);

    return panelVal ?? configVal ?? false;
  }

  isSubmitButtonLoading(): boolean {
    return this.getFnValue<boolean>(this.config?.submitButtonLoading) ?? false;
  }

  isPreviousButtonDisabled(panel: EoStepPanelConfig): boolean {
    let panelVal = this.getFnValue<boolean>(panel?.previousButtonDisabled);
    let configVal = this.getFnValue<boolean>(
      this.config?.previousButtonDisabled
    );

    return panelVal ?? configVal ?? false;
  }

  isNextButtonDisabled(panel: EoStepPanelConfig): boolean {
    let panelVal = this.getFnValue<boolean>(panel?.nextButtonDisabled);
    let configVal = this.getFnValue<boolean>(this.config?.nextButtonDisabled);

    return panelVal ?? configVal ?? false;
  }

  isSubmitButtonDisabled(): boolean {
    return this.getFnValue<boolean>(this.config?.submitButtonDisabled) ?? false;
  }

  getFnValue<T>(obj?: T | ((e?: any) => T)) {
    if (obj === undefined) return undefined;
    if (typeof obj === 'function') return (obj as (e?: any) => T)();
    return obj;
  }

  getStepContent(index: number): TemplateRef<any> | null {
    if (Array.isArray(this.stepContent)) return this.stepContent[index];
    return this.stepContent ?? null;
  }
}
